/**
 * Wrapin hook + gift wrap add flow.
 *
 * After theme:cart:refresh, the cart web component runs getCart() → build() → enableCartButtons().
 * That re-enables EVERY <button> inside the cart unless it has data-remain-disabled.
 * So we set disabled + data-remain-disabled together, and re-sync from /cart.js on theme:cart:change.
 */

var WRAPIN_VENDOR = 'wrapin';
var giftWrapCartSyncTimer;

function cartHasWrapinVendor(cart) {
  if (!cart || !cart.items || !cart.items.length) {
    return false;
  }
  return cart.items.some(function (item) {
    return (item.vendor || '').toLowerCase() === WRAPIN_VENDOR;
  });
}

function fetchCartJson() {
  return fetch(window.Shopify.routes.root + 'cart.js', {
    headers: { Accept: 'application/json' }
  }).then(function (r) {
    return r.json();
  });
}

function setGiftWrapButtonLocked($btn, locked) {
  if (!$btn || !$btn.length) {
    return;
  }
  $btn.prop('disabled', locked);
  $btn.attr('aria-disabled', locked ? 'true' : 'false');
  if (locked) {
    $btn.attr('data-remain-disabled', 'true');
  } else {
    $btn.removeAttr('data-remain-disabled');
  }
}

function updateGiftWrapButtonFromCart(cart) {
  var $ = window.jQuery;
  if (!$) {
    return;
  }
  var $btn = $('#ptw-add-gift-pro-ck');
  if (!$btn.length) {
    return;
  }
  setGiftWrapButtonLocked($btn, cartHasWrapinVendor(cart));
}

function scheduleGiftWrapButtonSync() {
  clearTimeout(giftWrapCartSyncTimer);
  giftWrapCartSyncTimer = setTimeout(function () {
    fetchCartJson()
      .then(updateGiftWrapButtonFromCart)
      .catch(function (e) {
        console.warn('Gift wrap cart sync failed', e);
      });
  }, 100);
}

function ptwUpdateCartNote(note) {
  var body = new URLSearchParams();
  body.set('note', note || '');
  // Clear any existing gift-note attribute to ensure it's only in note field
  body.set('attributes[gift-note]', '');

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'Accept': 'application/json'
    },
    body
  })
    .then(function (r) {
      if (!r.ok) {
        throw new Error('Cart update failed: ' + r.status);
      }
      return r.json();
    })
    .then(function (cart) {
      // Validate that note was actually saved
      if (cart.note !== note) {
        console.warn('Note mismatch: expected "' + note + '", got "' + cart.note + '"');
      }
      // Dispatch cart refresh event to update UI
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      return cart;
    })
    .catch(function (error) {
      console.error('Failed to update cart note:', error);
      throw error;
    });
}

function ptwAfterWrapinLoadHook() {
  var $ = window.jQuery;

  // UI tweaks
  $('.ptw-gift-image').prependTo('.ptw-app-label label');
  $('#ptw-add-gift-pro')
    .attr({ id: 'ptw-add-gift-pro-ck', type: 'button' })
    .removeClass('button');

  // Add gift wrap variant and mark the cart as gift-wrapped (no notes)
  $('#ptw-add-gift-pro-ck')
    .off('click.ptwGiftWrap')
    .on('click.ptwGiftWrap', function (e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop('disabled')) {
        return;
      }
      var variantId = $('#ptw-variant-id').val();

      // data-remain-disabled: theme enableCartButtons() skips this button after cart HTML refresh
      setGiftWrapButtonLocked($btn, true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          items: [{ quantity: 1, id: variantId }]
        }
      })
        .done(function () {
          var body = new URLSearchParams();
          body.set('attributes[gift-wrapped]', 'true'); // no gift-note / order note

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Accept: 'application/json'
            },
            body: body
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
            });
        })
        .fail(function () {
          setGiftWrapButtonLocked($btn, false);
        });
    });

  scheduleGiftWrapButtonSync();
}

document.addEventListener('theme:cart:change', scheduleGiftWrapButtonSync);

// Attach gift note handler independently when DOM is ready
// This ensures it works even if ptwAfterWrapinLoadHook gets overwritten
(function() {
  function attachGiftNoteHandler() {
    var $ = window.jQuery;
    if (!$) {
      // jQuery not loaded yet, try again
      setTimeout(attachGiftNoteHandler, 100);
      return;
    }
    
    // Use event delegation so it works even if button is added dynamically
    // Remove any existing handler first to avoid duplicates
    $(document).off('click', '#giftNoteCta').on('click', '#giftNoteCta', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      var noteVal = $('#gift-note').val() || '';
      var $btn = $(this);
      var originalText = $btn.text();
      var $textarea = $('#gift-note');
      
      // Disable button during update to prevent double-clicks
      $btn.prop('disabled', true);
      $btn.text('Adding...');

        ptwUpdateCartNote(noteVal.trim())
          .then(function () {
            $btn.text('Gift Note Added!');
            setTimeout(function () {
              $btn.text(originalText);
              $btn.prop('disabled', false);
              // Keep the note value in the field since it's saved
              // It will be repopulated on cart refresh anyway
            }, 1000);
          })
          .catch(function (error) {
            // Re-enable button on error and show error state
            $btn.text('Error - Try Again');
            $btn.prop('disabled', false);
            setTimeout(function () {
              $btn.text(originalText);
            }, 2000);
            console.error('Gift note update failed:', error);
          });
      });
  }
  
  // Try to attach immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachGiftNoteHandler);
  } else {
    attachGiftNoteHandler();
  }
  
  // Also re-attach when cart refreshes (for dynamic cart drawer updates)
  document.addEventListener('theme:cart:refresh', function() {
    setTimeout(attachGiftNoteHandler, 100);
  });
})();

window.addEventListener('pageshow', function () {  
  // Clean up: if gift-note exists in attributes but not in note, move it to note
  // Also clear the attribute to ensure data consistency
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var note = cart.note || '';
      var hasAttr = cart.attributes && cart.attributes['gift-note'];
      
      // If attribute exists but note doesn't, extract note from attribute and save to note
      if (hasAttr && !note) {
        var attrValue = cart.attributes['gift-note'];
        // Extract note from attribute (format: 'gift-note\n' + note)
        var extractedNote = attrValue.replace(/^gift-note\s*\n?/i, '').trim();
        if (extractedNote) {
          return ptwUpdateCartNote(extractedNote);
        }
      }
      
      // If attribute exists (even if note also exists), clear it to maintain consistency
      if (hasAttr) {
        return ptwUpdateCartNote(note);
      }
    })    
    .catch(function (err) {
      console.warn('gift-note resync failed', err);
    });
});